import script from "./GalleryDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryDetailView.vue?vue&type=script&setup=true&lang=js"

import "./GalleryDetailView.vue?vue&type=style&index=0&id=78bcf18b&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78bcf18b"]])

export default __exports__